// extracted by mini-css-extract-plugin
export default {"Loading":"beb_a bik_a bik_w bik_j bik_ul bik_um bik_fm"};